































































































import Vue, { PropType } from "vue";
import { meishiPath } from "@/model/path";
import { OrderPrice } from "@/model/price.ts";

export default Vue.extend({
  name: "CurrentOrderDetails",

  props: {
    orderPrice: {
      type: Object as PropType<OrderPrice>,
      required: true
    }
  },

  mounted() {
    // order_scroll.js再読み込み
    let orderScrollJs = document.getElementById("order-scroll");
    if (orderScrollJs !== null) {
      orderScrollJs.remove();
    }
    orderScrollJs = document.createElement("script");
    orderScrollJs.setAttribute("type", "text/javascript");
    orderScrollJs.setAttribute("id", "order-scroll");
    orderScrollJs.setAttribute(
      "src",
      process.env.BASE_URL + "/sys-common/js/order_scroll.js"
    );
    document.head.appendChild(orderScrollJs);
  },

  computed: {
    meishiPath,
    blockCopyPriceJp(): string {
      switch (true) {
        case this.orderPrice.blockCopyPrice === 1500:
          return "版下作成代（片面）";
        case this.orderPrice.blockCopyPrice === 2000:
          return "版下作成代（両面）";
        default:
          return "版下作成代";
      }
    }
  },

  methods: {
    openFrontSideModalBtnClick(): void {
      this.$emit("openFrontSideModalBtnClick");
    },
    openBackSideModalBtnClick(): void {
      this.$emit("openBackSideModalBtnClick");
    }
  }
});
